import React, { memo, useMemo } from 'react';
import PropTypes from 'prop-types';
import { Icon, createUseStyles } from '@Sage/hoi-poi-ui';

import { useWeb5Context } from 'lib/Web5Context';

import styles from './styles';

const useStyles = createUseStyles(styles, 'PdfViewerToolbar');

const Toolbar = memo(
    ({
        fullscreen,
        goToNextPage,
        goToPrevPage,
        numPages,
        page,
        scale,
        toggleFullscreen,
        toolbarExtra,
        zoomIn,
        zoomOut,
    }) => {
        const { t } = useWeb5Context();
        const classes = useStyles();

        const iconProps = useMemo(
            () => ({
                className: `${classes.toolbarItem} ${classes.toolbarIcon}`,
                color: 'currentColor',
                size: 'large',
            }),
            [classes.toolbarIcon, classes.toolbarItem],
        );

        const pagination = useMemo(() => {
            return t('label_generic_range', [page, numPages]);
        }, [numPages, page, t]);

        if (!page || !numPages) {
            return null;
        }

        return (
            <div className={classes.toolbar}>
                <div className={classes.toolbarItems}>
                    <Icon {...iconProps} name="chevronLeft" onClick={goToPrevPage} />
                    <span className={classes.toolbarItem}>{pagination}</span>
                    <Icon {...iconProps} name="chevronRight" onClick={goToNextPage} />
                </div>
                <div className={classes.toolbarItems}>
                    <Icon {...iconProps} name="less" onClick={zoomIn} />
                    <span className={classes.toolbarItem}>{`${scale.current * 100}%`}</span>
                    <Icon {...iconProps} name="add" onClick={zoomOut} />
                </div>
                <div className={classes.toolbarItems}>
                    <Icon
                        {...iconProps}
                        name={fullscreen ? 'fullscreenArrowsExit' : 'fullscreenArrows'}
                        onClick={toggleFullscreen}
                    />
                </div>
                {toolbarExtra}
            </div>
        );
    },
);

Toolbar.propTypes = {
    fullscreen: PropTypes.bool,
    goToNextPage: PropTypes.func.isRequired,
    goToPrevPage: PropTypes.func.isRequired,
    numPages: PropTypes.number,
    page: PropTypes.number.isRequired,
    scale: PropTypes.shape({
        current: PropTypes.number.isRequired,
        min: PropTypes.number.isRequired,
        max: PropTypes.number.isRequired,
        delta: PropTypes.number.isRequired,
    }).isRequired,
    toggleFullscreen: PropTypes.func.isRequired,
    toolbarExtra: PropTypes.node,
    zoomIn: PropTypes.func.isRequired,
    zoomOut: PropTypes.func.isRequired,
};

export default Toolbar;
